import styled from 'styled-components'

export const Container = styled.div`
  color: #fff;
  position: relative;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/UnfoldList/styledComponents.tsx